import { hasSession } from '../auth/session';
const parseJwt = (token: string) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

export const getPermissions = (token: string): string[] => {
  // Null-safe: a malformed token or one without a scope claim yields no
  // permissions instead of throwing (which would blank the app).
  const claims = parseJwt(token);
  const scope = (claims?.scope || '').trim();
  return scope === '' ? [] : scope.split(' ');
};

export const isUserLoggedIn = () => {
  // A stored user id plus a usable session (a live access token, or a refresh
  // token that initSession() will exchange for one). Short access tokens no
  // longer log the user out the moment they expire.
  return !!localStorage.getItem('id') && hasSession();
};

export const getOrgUserId = (): string => {
  const token = localStorage.getItem('token');
  const decoded = token ? parseJwt(token) : null;
  return decoded?.org_user_id || '';
};
